
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { UserModule } from '@/store/modules/user'
import { lbCompanyUserList, lbCompanyUserCount } from '@/api/systemset'
import { getProxyType } from '@/api/common/common'
import { MessageBox } from 'element-ui'
import { resetPwd } from '@/api/agentcenter'
@Component({
  name: 'user-manage',
  components: {
    SimpleTable,
    DictSelect
  }
})
export default class UserManage extends Vue {
  get userName () {
    return UserModule.name
  }

  private dialogVisible = !1

  private detailData: any = {}

  private form: any = {
    createTime: []
  }

  private closeDialog () {
    // do
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 1
  }

  private columns = [{
    prop: 'userAccount',
    label: '账号'
  },
  {
    prop: 'userName',
    label: '姓名'
  },
  {
    prop: 'state',
    label: '状态',
    custom: !0
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private pickerOptions = {
    shortcuts: [
      {
        text: '上一周',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近一个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近三个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }
    ],
    disabledDate: !0,
    firstDayOfWeek: 7,
    cellClassName: () => 'custClass',
    onPick: null
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const temp = { ...this.form }
    const form = util.trimForm({ ...temp })
    await lbCompanyUserList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await lbCompanyUserCount({
        ...form,
        ...pagination || this.pagination
      }).then((CntRes: any) => {
        this.loading = !1
        this.tableData.list = res.object.list
        this.tableData.totalCount = CntRes.object.totalCount
      }).catch((err: any) => {
        console.log('err', err)
        this.loading = !1
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private selectedRow: any[] = []

  private selectionChange (selected: any) {
    this.selectedRow = selected
  }

  private async onResetPwd () {
    // 重置代码
    if (!this.selectedRow || this.selectedRow.length === 0) {
      this.$alert('请选择账号')
      return
    }
    const ids = this.selectedRow.map((v: any) => v.id)
    const tbsUserIds = this.selectedRow.map((v: any) => v.tbsUserId)
    MessageBox.confirm(
      '提示：是否重置密码为888888', '密码重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
      await resetPwd({
        tbsUserIds: tbsUserIds.join(','),
        ids: ids.join(',')
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
        }
      })
    })
  }

  private legalType (val: any) {
    const dict: any = {
      1: '合法使用',
      2: '非法使用',
      3: '越权使用',
      4: '无权使用'
    }
    return dict[val]
  }

  private onReset () {
    this.form = {
    }
    this.onQuery()
  }

  private proTypeData: any = []

  private async initData () {
    await getProxyType({}).then((res: any) => {
      if (res.code === 10000) {
        this.proTypeData = [res.object.rpcOptions]
      }
    })
  }

  beforeMount () {
    this.initData()
    this.onQuery()
  }
}
